
import { Star, CheckCircle } from "lucide-react";
import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";

interface ChefName {
  first_name: string;
  last_name: string;
}

interface MealChefInfoProps {
  name: ChefName;
  rating: number;
  image: string;
  chefId: string;
  isCertified?: boolean;
}

export const MealChefInfo = ({ name, rating, image, chefId, isCertified = true }: MealChefInfoProps) => {
  const fullName = `${name.first_name} ${name.last_name}`.trim();
  const initials = fullName.split(' ').map(n => n[0]).join('').toUpperCase();

  return (
    <Link to={`/cook/${chefId}`} className="block">
      <div className="flex items-center hover:bg-gray-50 p-2 rounded-lg transition-colors">
        <Avatar className="h-12 w-12 shrink-0">
          <AvatarImage 
            src={image} 
            alt={fullName} 
            className="object-cover"
          />
          <AvatarFallback>{initials}</AvatarFallback>
        </Avatar>
        <div className="ml-3 flex-grow">
          <p className="font-medium text-black underline decoration-dotted decoration-1 underline-offset-4 mb-2">Chef {fullName}</p>
          <div className="flex items-center gap-2">
            <div className="flex items-center text-yellow-400">
              <Star className="w-4 h-4 fill-current" />
              <span className="ml-1 text-sm text-black">{rating}</span>
            </div>
            {isCertified && (
              <Badge variant="outline" className="bg-green-50 text-green-700 border-green-200 flex items-center gap-1">
                <CheckCircle className="w-3 h-3" />
                Certified Kitchen
              </Badge>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
};
